<template>
    <div>
        <div class="loading-spinner-outer" v-if="saving">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Saving, please wait
                </div>
            </div>
        </div>
        <div class="box">
            <div class="box-content">
                <div class="flex-2xs">
                    <div class="half-width-2xs pr-3-2xs">
                        <div class="form-group">
                            <label>Title</label>
                            <input type="text" v-model="news_post.title" class="form-control">
                        </div>
                        <div class="form-group">
                            <label>Publish At</label>
                            <datepicker input-class="form-control" v-model="news_post.publish_at"></datepicker>
                        </div>
                    </div>
                    <div class="half-width-2xs pl-3-2xs">
                        <div class="form-group">
                            <label>Category</label>
                            <select v-model="news_post.news_post_category_id" class="form-control">
                                <option v-for="category in categories" :value="category.id">{{ category.label }}</option>
                            </select>
                        </div>
                      <div class="form-group">
                        <label>Systems</label>
                        <div class="multi-select-input">
                          <div class="multi-select-input-placeholder" @click="system_dropdown_open = !system_dropdown_open">
                            <template v-if="selected_system_types.length > 0">
                              <span v-for="type in selected_system_types">{{ type.label }}, </span>
                            </template>
                            <template v-else>
                              Select Systems ...
                            </template>
                            <div class="dropdown-icon">
                              <i class="fal fa-chevron-down"></i>
                            </div>
                          </div>
                          <div class="multi-select-input-inner" v-show="system_dropdown_open">
                            <div class="multi-select-input-group">
                              <div class="checkboxes">
                                <div class="checkbox level-1" v-for="system_type in system_types">
                                  <label>
                                    <input type="checkbox" name="epwin_system_types" :value="system_type.id" v-model="news_post.epwin_system_type_ids">
                                    <span class="checkbox-label">{{ system_type.label }}</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="form-group">
                    <label>Synopsis</label>
                    <input type="text" v-model="news_post.summary" class="form-control">
                </div>
                <div class="form-group">
                    <label>Article Body</label>
                    <wysiwyg v-model="news_post.content"></wysiwyg>
                </div>
                <div class="flex-sm">
                    <div class="half-width-sm pr-3-sm">
                        <div class="form-group mb-0-sm full-height flex flex-col">
                            <label>Upload Image</label>
                            <form :action="`${$aws_upload_url}`" method="post"
                                  enctype="multipart/form-data" id="amazon_form">
                                <input type="hidden" name="policy" :value="aws_policy">
                                <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                                <input type="hidden" name="x-amz-credential" :value="aws_credential">
                                <input type="hidden" name="x-amz-date" :value="aws_date">
                                <input type="hidden" name="x-amz-signature" :value="aws_signature">
                                <input type="hidden" name="acl" value="private">
                                <input type="hidden" name="success_action_redirect" value="/news/manage">
                                <input type="hidden" name="Content-Type" v-model="filetype">
                                <input type="hidden" name="key" v-model="news_post.filename">
                            </form>
                            <vue-dropzone
                                ref="fileUploadDropzone"
                                id="dropzone"
                                :options="dropzoneOptions"
                                v-on:vdropzone-file-added="fileAddedToDropZone"
                                v-on:vdropzone-removed-file="fileRemovedFromDropZone"
                                :useCustomSlot="true"
                            >
                                <div>
                                    <div class="mb-3">
                                        DRAG AND DROP FILE
                                    </div>
                                    <div class="mb-3">
                                        OR
                                    </div>
                                    <div>
                                        <a class="btn-secondary-outline">
                                            Choose a file
                                        </a>
                                    </div>
                                </div>
                            </vue-dropzone>
                        </div>
                    </div>
                </div>
                <div class="align-right mt-3">
                    <a class="btn-primary" @click.prevent="save()">
                        Save
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import vue2Dropzone from 'vue2-dropzone';
import Datepicker from 'vuejs-datepicker';

export default {
    props: [
       'aws_policy',
       'aws_credential',
       'aws_date',
       'aws_signature',
       'categories',
       'system_types',
    ],
    components: {
        'vue-dropzone': vue2Dropzone,
        'datepicker': Datepicker,
    },
    data() {
        return {
            news_post: {
              epwin_system_type_ids: [],
            },
            loading: true,
            filename: '',
            filetype: '',
            saving: false,
            uploaded_file: null,
            dropzoneOptions: {
                url: '/',
                autoProcessQueue: false,
                uploadMultiple: true,
                addRemoveLinks: true,
            },
            tag_dropdown_open: false,
          system_dropdown_open: false,
        };
    },
    computed: {
      selected_system_types() {
        return this.system_types.filter((type) => this.news_post.epwin_system_type_ids.includes(type.id));
      },
    },
    methods: {
        fileAddedToDropZone(uploadedFile) {
            const extension = uploadedFile.name.replace(/^.*\./, '');

            const allowed_extensions = [
                'jpg', 'jpeg', 'png',  'svg', 'gif', 'bmp',
            ];

            if(!allowed_extensions.includes(extension.toLowerCase())) {
                this.$refs.fileUploadDropzone.dropzone.removeAllFiles();
                Swal.fire({
                    title: 'Invalid File Type',
                    icon: 'error',
                    text: 'File type not allowed, please ensure the file is one of the following formats: \'jpg\', \'jpeg\', \'png\',  \'svg\', \'gif\', \'bmp\','
                });
                return;
            }

            if (this.$refs.fileUploadDropzone.dropzone.files.length > 1) {
                this.$refs.fileUploadDropzone.dropzone.removeFile(this.$refs.fileUploadDropzone.dropzone.files[0]);
            }

            const filename = 'news_post_images/' + Date.now();
            this.news_post.filename = filename + '.' + extension;

            this.filetype = uploadedFile.type;
            this.uploaded_file = uploadedFile;
        },
        fileRemovedFromDropZone(file) {
          this.uploaded_file = null;
          this.news_post.filename = null;
          this.filetype = null;
        },
        save() {
          this.saving = true;
            const validationErrors = Validate({
                title: this.news_post.title,
                summary: this.news_post.summary,
                content: this.news_post.content,
                category: this.news_post.news_post_category_id,
                image: this.uploaded_file,
            }, {
                title: {
                    presence: {
                        allowEmpty: false,
                    },
                },
                summary: {
                    presence: {
                        allowEmpty: false,
                    },
                },
                content: {
                    presence: {
                        allowEmpty: false,
                    },
                },
                category: {
                    presence: {
                        allowEmpty: false,
                        message: 'must be chosen'
                    },
                },
                image: {
                    presence: {
                        allowEmpty: false,
                        message: 'must be uploaded'
                    },
                },
            });

            if (validationErrors) {
              this.saving = false;
                Swal.fire({
                    title: 'Unable to save post',
                    icon: 'error',
                    html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
                });
                return;
            }

            axios.post('/news/create',{
                news_post: this.news_post,
            }).then((response) => {
                let form_data = new FormData(document.querySelector('#amazon_form'));
                form_data.append('file', this.uploaded_file);
                axios({
                    method: 'post',
                    url: this.$aws_upload_url,
                    data: form_data,
                    headers: {'Content-Type': 'multipart/form-data' }
                }).then(() => {
                    window.location.href = '/news/manage';
                });
            });
        },
    },
};
</script>
